<template>
  <div class="background home">
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <div class="content">
      <img class="head" src="../assets/head.jpg" alt="head-img" />
      <h3>L.YQ</h3>
      <div class="whatsup">创意源于生活。</div>
      <div class="divider"></div>
      <div class="whatsup">Hi，我叫李煜泉，是一名Web前端开发者。</div>
      <div class="tolink">
        <a class="item" target="_blank" href="https://github.com/Quincyli666">Github</a>
        <router-link class="item resume" to="/resume">简&nbsp;历</router-link>
        <router-link class="item" to="/blog">博&nbsp;客</router-link>
      </div>
    </div>
    <div class="record">
      <a href="http://www.beian.miit.gov.cn/" target="_blank">粤ICP备2025468991号</a>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
// 内容待完善
// 故事还长，你不要太早失望。
// 影集
// 工作室
// 返回顶部，把右下角按钮改成右上角拉绳子方式。
/**
 * 待写插件：
 * 基于浏览器的播放器，包括移动端版本
 * 基于cordova的webAPP
 * 待写笔记：
 * 复制对象和合并对象
 * 深拷贝和浅拷贝
 */

// 笔记补充flex，css3动画

export default {
  name: "Home",
  components: {
    // HelloWorld
  },
};
</script>

<style lang="less">
@keyframes opacity {
  from {
    opacity: 0;
  }
  to {
    opacity: 0.15;
  }
}
.home {
  position: fixed;
  // text-align: center;
  &::before {
    content: "";
    width: 100%;
    height: 100%;
    background-image: url("../assets/background/cover-2.jpg");
    background-size: cover;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    // -webkit-filter: blur(3px);
    // filter: blur(3px);
    animation: opacity 3s forwards; /*animation-fill-mode*/
  }
}
.home > .content {
  width: 100%;
  height: 24rem;
  margin-top: -12rem;
  position: absolute;
  top: 50%;
  text-align: center;
  vertical-align: middle;
  .head {
    width: 5.6rem;
    height: 5.6rem;
    border-radius: 50%;
    border: 0.25rem solid #fff;
    margin-top: 2rem;
  }
  .whatsup {
    color: #607080;
    font-weight: lighter;
  }
  .tolink {
    display: flex;
    justify-content: center;
    margin-top: 2rem;
    .item {
      width: 5rem;
      height: 2.3rem;
      line-height: 2.3rem;
      margin: 0 0.3rem;
      border-radius: 1.6rem;
      border: 1px solid #aaa;
      color: #aaa;
      cursor: pointer;
      text-decoration: none;
      &:hover {
        border: 1px solid #a4e5ff;
        color: #fff;
        background-color: #a4e5ff;
      }
    }
  }
}
.home > .record {
  position: absolute;
  bottom: 1rem;
  width: 100%;
  font-size: 0.87rem;
  a {
    display: block;
    text-align: center;
    color: #607080;
    text-decoration: none;
  }
}
</style>